import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { PartnerHeadEditMode } from './components/partnerHeadEditMode/PartnerHeadEditMode'
import { PartnerHeadReadMode } from './components/partnerHeadReadMode/PartnerHeadReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './PartnerHead.module.scss'

interface IPartnerHeadProps {
  salesCount: Nullable<number>
  serviceCount: Nullable<number>
}

export const PartnerHead: FC<IPartnerHeadProps> = ({ salesCount, serviceCount }) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && <PartnerHeadReadMode salesCount={salesCount} serviceCount={serviceCount} />}
      {isEditMode && <PartnerHeadEditMode salesCount={salesCount} serviceCount={serviceCount} />}
    </div>
  )
}
